<template>
  <div class="page-container" style="display:flex;align-items:center;justify-content:center;">
    <div class="card-panel" style="width:100%;max-width:420px;padding:32px;">
      <h2 class="page-title">CoRecogN 登录</h2>
      <el-form :model="form" label-position="top">
        <el-form-item label="角色">
          <el-radio-group v-model="form.role">
            <el-radio-button label="admin">管理员</el-radio-button>
            <el-radio-button label="vendor">供应商</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="form.role === 'admin' ? '管理员账号' : '供应商编号'">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" show-password />
        </el-form-item>
        <el-button type="primary" style="width:100%;" @click="handleLogin">登录</el-button>
      </el-form>
      <p style="margin-top:16px;color:#909399;">初始管理员账号：admin / admin1234</p>
    </div>
  </div>
</template>

<script>
import { login } from '../api/auth'

export default {
  data() {
    return {
      form: {
        role: 'admin',
        username: '',
        password: '',
      },
    }
  },
  methods: {
    async handleLogin() {
      try {
        const { data } = await login(this.form)
        localStorage.setItem('token', data.token)
        localStorage.setItem('role', data.role)
        localStorage.setItem('name', data.name)
        if (data.vendorId) {
          localStorage.setItem('vendorId', String(data.vendorId))
        }
        this.$message.success('登录成功')
        this.$router.push(data.role === 'admin' ? '/admin/suppliers' : '/vendor/profile')
      } catch (error) {
        this.$message.error(error.response?.data?.message || '登录失败')
      }
    },
  },
}
</script>
